import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import api from "../Services/api";
import { isRural } from "../Utils/isRural";

export interface IAvaliacao {
  ID: number;
  CONFIRMADO: 1 | 0;
  CONTADOR: number;
}

interface IAvaliacaoContextData {
  createAvaliacao(imovel_id: number, confirmado: 1 | 0): Promise<void>;
  updateAvaliacao(imovel_id: number, confirmado: 1 | 0): Promise<void>;
  getAvaliacao(imovel_id: number): Promise<void>;
  avaliado: IAvaliacao;
}

interface IAvaliacaoProviderProps {
  children: ReactNode;
}

const AvaliacaoContext = createContext({} as IAvaliacaoContextData);

function AvaliacaoProvider({ children }: IAvaliacaoProviderProps) {
  const [avaliado, setAvaliado] = useState({} as IAvaliacao);

  async function getAvaliacao(imovel_id: number) {
    try {
      const { data } = await api.get(
        `/avaliado/${imovel_id}/${isRural() ? 1 : 0}`
      );

      if (data) {
        setAvaliado(data[0]);
      }
    } catch (error) {
      throw error;
    }
  }

  async function createAvaliacao(imovel_id: number, confirmado: 1 | 0) {
    try {
      // window.alert(
      //   "Create" +
      //     JSON.stringify({
      //       imovel_id,
      //       confirmado,
      //       rural: isRural() ? true : false,
      //     })
      // );
      const { data } = await api.post(`/avaliado`, {
        imovel_id,
        confirmado,
        rural: isRural() ? true : false,
      });
      if (data) {
        
        setAvaliado(data);
      }
    } catch (error) {
      
     
      throw error;
    }
  }

  async function updateAvaliacao(imovel_id: number, confirmado: 1 | 0) {
    try {
      // window.alert(
      //   "Update" +
      //     JSON.stringify({
      //       imovel_id,
      //       confirmado,
      //       rural: isRural() ? true : false,
      //     })
      // );
      const { data } = await api.patch(`/avaliado`, {
        imovel_id,
        confirmado,
        rural: isRural() ? true : false,
      });
      if (data) {
        setAvaliado(data);
      }
    } catch (error) {
      throw error;
    }
  }

  return (
    <AvaliacaoContext.Provider
      value={{
        createAvaliacao,
        updateAvaliacao,
        getAvaliacao,
        avaliado,
      }}
    >
      <>{children}</>
    </AvaliacaoContext.Provider>
  );
}

function useAvaliacao() {
  const context = useContext(AvaliacaoContext);

  return context;
}

export { AvaliacaoProvider, useAvaliacao };
